import View from '@play-co/timestep-core/lib/ui/View';
import { ImageScaleView, ImageView } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import bitmapFonts from 'src/lib/bitmapFonts';
import i18n from 'src/lib/i18n/i18n';
import { user, now } from 'src/StateObserver';
import * as Gifts from 'src/replicant/gifts';

const WIDTH = 170;
const HEIGHT = 77;
const LABEL_HEIGHT = 35;
const GEM_WIDTH = 26;
const GEM_GAP = 8;

/**
 * Gift gems collected today out of the daily allowance (#12235).
 */
export class GiftsCollectedCounter extends View {
  private gem: ImageView;
  private value: LangBitmapFontTextView;

  constructor(opts: { superview: View; x: number; y: number }) {
    super({
      tag: 'gifts-collected-counter',
      superview: opts.superview,
      x: opts.x,
      y: opts.y,
      width: WIDTH,
      height: HEIGHT,
    });

    new ImageScaleView({
      superview: this,
      image: 'assets/ui/gifts/gifts_counter_frame.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 14, right: 14 },
        vertical: { top: 14, bottom: 14 },
      },
      width: WIDTH,
      height: HEIGHT,
    });

    new LangBitmapFontTextView({
      superview: this,
      width: WIDTH,
      height: LABEL_HEIGHT,
      align: 'center',
      verticalAlign: 'center',
      size: 20,
      color: '#BF8147',
      wordWrap: false,
      font: bitmapFonts('Body'),
      localeText: () => i18n('gifts.popupGiftsList.collectedLabel'),
    });

    new View({
      superview: this,
      y: LABEL_HEIGHT,
      width: WIDTH,
      height: 2,
      backgroundColor: '#FEE4B1',
    });

    this.gem = new ImageView({
      superview: this,
      image: 'assets/ui/shared/icons/gem.png',
      y: 46,
      width: GEM_WIDTH,
      height: 23,
    });

    this.value = new LangBitmapFontTextView({
      superview: this,
      y: LABEL_HEIGHT + 2,
      width: WIDTH - GEM_WIDTH - GEM_GAP,
      height: HEIGHT - LABEL_HEIGHT - 2,
      align: 'left',
      verticalAlign: 'center',
      size: 25,
      color: '#9A7171',
      wordWrap: false,
      font: bitmapFonts('Body'),
      localeText: () => '',
    });

    this.refresh();
  }

  public refresh() {
    const max = Gifts.ruleset.maxDailyGiftGems;
    // Two devices can collect at the same moment and pass the cap, see #12235
    const collected = Math.min(
      max,
      Gifts.getters.getGiftGemsCollectedToday(user(), now()),
    );
    this.value.localeText = () => `${collected}/${max}`;

    // Center the gem and the number together, the number width varies
    const groupWidth = GEM_WIDTH + GEM_GAP + this.value.getTextWidth();
    this.gem.style.x = (WIDTH - groupWidth) / 2;
    this.value.style.x = this.gem.style.x + GEM_WIDTH + GEM_GAP;
  }
}
